<template>
  <div>
    <modalcart v-model="dialog" />
    <v-snackbar v-model="alert.show" timeout="2000" right top :color="alertColor">
      {{ alert.message }}
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="hideAlert">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>

    <v-app-bar flat app height="90" light class="header-frame bg-white">
      <div class="px-3" id="brand-bar">
        <router-link :to="'/'" class="mr-5">
          <v-img class="img-logo" width="60" contain :src="siteConfig.logo"></v-img>
        </router-link>
        <!-- <router-link :to="'/'" class="d-block d-sm-none d-xs-block">
          <v-img class="img-logo" width="80" :src="siteConfig.favicon"></v-img>
        </router-link> -->
        <!-- <div class="dividers black--text">&nbsp;</div> -->
        <div class="seller-headtitle black--text">Seller Centre</div>
      </div>

      <div id="feature-bar" class="seller-features" v-if="userData">
        <v-menu dark offset-y class="d-none d-sm-block d-xs-none" content-class="user-menu-content" id="user-bar">
          <template v-slot:activator="{ on, attrs }">
            <v-btn text v-bind="attrs" v-on="on" class="mt-md-n2 px-0 bg-transparent" id="userbtn-bar" elevation="0">
              <div class="font-weight-bold">
                <span class="d-none d-sm-block d-xs-none pl-2">{{ userData ? userData.user_name : "" }}</span>
                <div class="d-block d-sm-none d-xs-block">
                  <v-img width="24" src="/assets/icons/account.svg"></v-img>
                </div>
              </div>
              <v-icon>mdi-chevron-down</v-icon>
            </v-btn>
          </template>

          <v-list dark color="white" id="user-menu">
            <v-list-item link @click.native="gotoProfile">
              <v-icon class="pr-3 grey--text text--darken-1">mdi-account</v-icon>
              <v-list-item-content>
                <v-list-item-title class="grey--text text--darken-2">Profil</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item link @click.native="gotoMyStore" v-if="['seller', 'stockist'].includes(userData.user_type)">
              <span class="pr-2 ml-n1">
                <v-img width="32" src="/assets/icons/icon-toko.svg"></v-img>
              </span>
              <v-list-item-content>
                <v-list-item-title class="grey--text text--darken-2">Toko Saya</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item link @click.native="gotoTransaction">
              <v-icon class="pr-3 grey--text text--darken-1">mdi-format-list-bulleted</v-icon>
              <v-list-item-content>
                <v-list-item-title class="grey--text text--darken-1">Transaksi</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item link @click.native="onLogout">
              <v-icon class="pr-3 grey--text text--darken-1">mdi-exit-to-app</v-icon>
              <v-list-item-content>
                <v-list-item-title class="grey--text text--darken-2">Logout</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>

        <!-- <v-btn @click="$emit('showDrawer')" text fab x-small  class="mt-md-n2 px-0 bg-transparent" id="sellerbtn-bar"
          elevation="0">
          <v-icon size="30" color="black">{{ 'mdi-menu' }}</v-icon>
        </v-btn> -->
          <v-app-bar-nav-icon @click="$emit('showDrawer')" ></v-app-bar-nav-icon>
        <!-- <v-menu left v-if="isMobile" offset-y class="d-none" content-class="menuseller-menu-content"
          :close-on-content-click="true" id="menuseller-bar">
          <template v-slot:activator="{ on, attrs }">
          </template>

          <v-list color="white" class="seller-feature-item" v-if="!isMobile">
            <template v-for="(item, idx) in features">
              <v-list-item :key="idx" link @click.native="gotoFeature(item.to)" :class="checkPermission(item.title)">
                <v-img width="50" :src="item.icon"></v-img>
                <v-list-item-content>
                  <v-list-item-title class="grey--text text--darken-2">{{ item.title }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-list>

          <v-list dark color="white" class="seller-feature-item" v-else>
            <template v-for="(item, idx) in items">
              <template v-if="item.children.length === 0">
                <v-list-item :key="idx" link @click.native="gotoFeature(item.to)" :class="checkPermission(item.title)">
                  <v-img width="50" :src="item.icon"></v-img>
                  <v-list-item-content>
                    <v-list-item-title class="grey--text text--darken-2">{{ item.title }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>

              <template v-else>
                <template v-for="(sub, ids) in item.children">
                  <v-list-item :key="idx + '-' + ids" link @click.native="gotoFeature(sub.to)"
                    :class="checkPermission(sub.title)">
                    <v-img width="50" :src="item.icon"></v-img>
                    <v-list-item-content>
                      <v-list-item-title class="grey--text text--darken-2">{{ sub.title
                        }}{{ checkPermission(sub.title) }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </template>
            </template>
          </v-list>
        </v-menu> -->
      </div>
    </v-app-bar>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations, mapGetters } from "vuex";

export default {
  components: {},
  props:['value'],
  data() {
    return {
      drawer: false,
      searchDrawer: false,
      dialog: false,
      isMobile: false,
      features: [
        {
          to: "/seller/produk-saya",
          icon: "/assets/seller/header/produk-saya-icon.svg",
          title: "Produk Saya"
        },
        {
          to: "/seller/pesanan-saya",
          icon: "/assets/seller/header/pesanan-saya-icon.svg",
          title: "Pesanan Saya"
        },
        // {
        //   to: "/seller/produk-eksklusif",
        //   icon: "/assets/seller/header/produk-eksklusif-icon.svg",
        //   title: "Produk Reseller"
        // },
        {
          to: "/seller/pembelian",
          icon: "/assets/seller/header/order-icon.svg",
          title: "Pembelian Produk"
        },
        {
          to: "/seller/penghasilan-saya",
          icon: "/assets/seller/header/penghasilan-saya-icon.svg",
          title: "Penghasilan Saya"
        },
        {
          to: "/seller/pengaturan-pengiriman",
          icon: "/assets/seller/header/pengiriman-saya-icon.svg",
          title: "Pengaturan Pengiriman"
        }
        // {
        //   to: 'saldo-saya',
        //   icon: '/assets/seller/header/saldo-saya-icon.svg',
        //   title: 'Saldo Saya'
        // },
        // {
        //   to: '/seller/pengaturan-dasar',
        //   icon: '/assets/seller/header/pengaturan-dasar-icon.svg',
        //   title: 'Pengaturan Dasar'
        // }
      ],
      items: [
        {
          icon: "/assets/seller/dashboard.svg",
          title: "Dashboard",
          to: "/seller/dashboard",
          children: []
        },
        {
          icon: "/assets/seller/pesanan.svg",
          title: "Pesanan",
          to: "/seller",
          children: [
            {
              title: "Pesanan Saya",
              to: "/seller/pesanan-saya"
            }
          ]
        },
        {
          icon: "/assets/seller/produk.svg",
          title: "Produk",
          to: "/seller",
          children: [
            {
              title: "Produk Saya",
              to: "/seller/produk-saya"
            },
            {
              title: "Tambah Produk Baru",
              to: "/seller/tambah-produk"
            },
            // {
            //   title: "Produk Eksklusif",
            //   to: "/seller/produk-eksklusif"
            // },
            {
              title: "Order Produk Reseller",
              to: "/seller/pembelian"
            }
          ]
        },
        {
          icon: "/assets/seller/penghasilanmu.svg",
          title: "Penghasilan",
          to: "/seller",
          children: [
            {
              title: "Penghasilan Saya",
              to: "/seller/penghasilan-saya"
            },
            {
              title: "Rekening Bank",
              to: "/seller/rekening-bank"
            }
          ]
        },
        {
          icon: "/assets/seller/tentang-toko.svg",
          title: "Tentang Toko",
          to: "/seller",
          children: [
            {
              title: "Profil Toko",
              to: "/seller/profile-toko-v3"
            }
          ]
        },
        {
          icon: "/assets/seller/pengaturan.svg",
          title: "Pengaturan",
          to: "/seller",
          children: [
            {
              title: "Pengaturan Pengiriman",
              to: "/seller/pengaturan-pengiriman"
            }
          ]
        }
      ]
    };
  },
  computed: {
    ...mapState("kiriminaja", [
      "siteConfig",
    ]),
    ...mapState("auth", ["isAuth", "userData"]),
    ...mapState("storeSeller", ["detailStore"]),
    ...mapGetters("storeSeller", ["isStoreB2b"]),
    ...mapState(["alert"]),

    alertColor() {
      switch (this.alert.type) {
        case "success":
          return "primary";
        case "warning":
          return "yellow";
        default:
          return "red";
      }
    },

    windowWidth() {
      return this.getWindowWidth();
    }
  },
  methods: {
    ...mapActions("auth", ["logout"]),
    ...mapMutations(["hideAlert"]),

    getWindowWidth() {
      let screen = document.documentElement.clientWidth;
      if (screen <= 960) this.isMobile = true;
      else this.isMobile = false;
    },
    wdrawer() {
      if (window.matchMedia("(min-width: 960px)").matches) {
        this.drawer = false;
      }
    },
    gotoFeature(link) {
      this.$router.push(link);
    },
    gotoProfile() {
      this.$router.push({
        name: "profile"
      });
    },
    gotoTransaction() {
      this.$router.push("/transaction").catch(() => { });
    },
    gotoMyStore() {
      this.$router.push({
        name: "seller-dashboard"
      });
      // let routeData = this.$router.resolve({ name: "seller-dashboard" });
      // window.open(routeData.href, "_blank");
    },
    checkPermission(title) {
      const restrictUrl = [
        "Produk Eksklusif",
        "Pembelian Produk",
        "Order Produk Eksklusif"
      ];
      const check = restrictUrl.filter(d => d === title);
      if (
        check.length &&
        (this.userData.user_is_stockist.toLowerCase() !== "true" ||
          this.isStoreB2b)
      )
        return "d-none";
    },
    onLogout() {
      // this.logout().then(() => {
      //   if (this.$route.name && this.$route.name != "home") {
      //     this.$router.push({
      //       name: "home"
      //     });
      //   }
      // });
      this.$store.dispatch("auth/logout").then(() => {
        // window.location.href = `${process.env.VUE_APP_HOMEPAGE}`;
        window.location.replace(process.env.VUE_APP_HOMEPAGE + "logout ");
      });
    },
    cari() {
      if (this.search_text) {
        this.$router.push({
          name: "search-product",
          params: {
            search: this.search_text
          }
        });
      }
    },
    clearSearch() {
      this.searchDrawer = false;
    }
  },
  async created() {
    await this.getWindowWidth();
    await window.addEventListener("resize", this.getWindowWidth);

    var link = await document.querySelector("link[rel*='icon']") || document.createElement('link');
    link.type = await 'image/x-icon';
    link.rel = await 'shortcut icon';
    link.href = await this.siteConfig.favicon;
    await document.getElementsByTagName('head')[0].appendChild(link);
  },
  destroyed() {
    window.addEventListener("resize", this.getWindowWidth);
  }
};
</script>
<style lang="scss" scoped>
#brand-bar {
  display: flex;
  flex-direction: row;
  align-items: center;

  .seller-headtitle {
    color: #fff;
    font-size: 20px;
    height: 23px;
    font-weight: bold;
  }

  .dividers {
    display: block;
    margin: 0 25px;
    width: 1px;
    background: #fff;
    height: 40px;
  }
}

#feature-bar {
  text-align: right;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  flex: auto;
  padding-left: 25px;
}

.small-logo {
  background: #fff;
  width: 40px;
  height: 40px;
  padding: 6px 8px;
  border-radius: 4px;

  .v-image {
    display: block;
    margin: 0 auto;
  }
}

#mini-search-bar {
  .v-image {
    .v-image__image {
      background-size: 20px !important;
    }
  }
}

@media (max-width: 599px) {

  #cart-bar,
  #message-bar,
  #seller-message-bar,
  #mini-search-bar {
    padding-left: 7px !important;
    padding-right: 7px !important;
  }

  .header-frame {
    #brand-bar {
      .dividers {
        display: none;
      }

      .seller-headtitle {
        padding-left: 15px;
        font-size: 1rem;
        line-height: normal;
        height: 40px;
        display: flex;
        align-items: center;
      }
    }
  }

  .user-menu-content {
    width: 100% !important;
    height: 100% !important;
    left: 0px !important;
    top: 60px !important;
    height: 100% !important;
    max-width: 100% !important;
    padding-top: 15px !important;

    #user-menu {
      height: 100%;

      .v-list-item:hover {
        background: rgba(0, 0, 0, 0.05);
      }
    }
  }

  .menuseller-menu-content {
    width: 100% !important;
    height: 100% !important;
    left: 0px !important;
    top: 60px !important;
    height: 100% !important;
    max-width: 100% !important;
    padding-top: 15px !important;
    overflow: hidden !important;
    box-shadow: none !important;

    .seller-feature-item {
      height: 100%;
      width: 100%;

      .v-list-item {
        margin: 0 2% 4%;
      }
    }

    .seller-feature-item.mobile-item {
      height: 90vh;
      width: 100%;
      position: fixed;
      left: 0;
      overflow-y: auto;

      .v-list-item {
        flex: 1 0 100%;
        margin: 0 0% 4%;
        width: 100%;
        flex-direction: row;
        padding: 0 !important;
        height: 50px;
        align-items: center;
        background: #e9e9e9;
        border-radius: 0 !important;

        .v-image {
          width: 42px !important;
          height: 42px !important;
          flex: none;
          background: transparent;
          // background: #e5e5e5;

          .v-image__image {
            background-size: 90% auto !important;
            opacity: 1;
          }
        }

        .v-list-item__content {
          padding: 0;
          flex: auto;
          height: auto;
          padding-left: 5px;
          font-weight: bold;

          .v-list-item__title {
            height: auto;
            text-align: left;
          }
        }
      }

      .child-items {
        width: 100%;
        display: flex;

        .v-list-item-sub {
          align-items: center;

          .v-image {
            height: 50px;
            background: #0ea35c !important;
            border-radius: 100% !important;
            display: block;
            margin: 0 auto;
          }

          .text-subtitle-2 {
            line-height: normal;
            text-align: center;
          }
        }
      }
    }
  }

  #feature-bar {
    padding-left: 5px;
  }
}
</style>
